import { uploadSingleFile } from "../files";
import { authClient, API } from "../index";

// Get all users (for backward compat: EditCursoPage, etc.)
export const getUsers = (queryString = "") => {
  const qs = queryString && !queryString.startsWith("?") ? `?${queryString}` : queryString || "";
  return authClient().get(`${API}/user${qs || "?getDisabled=true"}`);
};

// Get users paginated with filters (for UsersPage and SociosPage)
export const getUsersPaginated = (params) => {
  const searchParams = new URLSearchParams();
  // Solo incluir inactivos si no se pide explícitamente solo activos (ej. newsletter debe listar solo activos)
  if (params.onlyActive !== true) searchParams.set("getDisabled", "true");
  if (params.onlyActive) searchParams.set("active", "true");
  if (params.page) searchParams.set("page", params.page);
  if (params.limit) searchParams.set("limit", params.limit);
  if (params.role) searchParams.set("role", params.role);
  if (params.asociado) searchParams.set("asociado", "true");
  const tipoUsuario = params.tipoUsuario;
  if (Array.isArray(tipoUsuario) && tipoUsuario.length) {
    tipoUsuario.forEach((id) => searchParams.append("tipoUsuario", id));
  } else if (tipoUsuario) {
    searchParams.set("tipoUsuario", tipoUsuario);
  }
  if (params.provincia) searchParams.set("provincia", params.provincia);
  if (params.fechaAltaDesde) searchParams.set("fechaAltaDesde", params.fechaAltaDesde);
  if (params.fechaAltaHasta) searchParams.set("fechaAltaHasta", params.fechaAltaHasta);
  if (params.numeroSocio) searchParams.set("numeroSocio", params.numeroSocio);
  if (params.nAso) searchParams.set("nAso", params.nAso);
  if (params.active) searchParams.set("active", "true");
  if (params.search) searchParams.set("search", params.search);
  if (params.sortBy) searchParams.set("sortBy", params.sortBy);
  if (params.sortOrder) searchParams.set("sortOrder", params.sortOrder);
  return authClient().get(`${API}/user?${searchParams.toString()}`);
};

/** Siguiente nº de socio previsto (lectura del contador; no incrementa). */
export const getNextSocioNumberPreview = () => {
  return authClient().get(`${API}/user/next-socio-number-preview`);
};

// Get user by id
export const getUserById = (id) => {
  return authClient().get(`${API}/user/${id}`);
};

// Delete user
export const deleteUser = (id) => {
  return authClient().delete(`${API}/user/${id}`);
};

// Create user (backoffice). El campo nAso lo asigna el servidor si asociado === true (ver user.controller.add).
export const postUser = async (user, image) => {
  if (image) {
    const response = await uploadSingleFile(image, "users");
    user.imageURL = response?.data?.fileURL;
  }
  return authClient().post(`${API}/user`, user);
};

// Update user
export const updateUser = async (id, user, image) => {
  if (image) {
    const response = await uploadSingleFile(image, "users");
    user.imageURL = response?.data?.fileURL;
  }
  return authClient().put(`${API}/user/${id}`, user);
};

// Count all admins
export const countAdmins = () => {
  const role = "admin";
  return authClient().get(`${API}/user/count/${role}`);
};

// Change status user
export const changeStatusUser = async (id, active) => {
  return authClient().put(`${API}/user/change-status/${id}`, { active });
};

// Reset user password
export const resetUserPassword = async (id, password) => {
  return authClient().put(`${API}/user/reset-password/${id}`, { password });
};